export enum UserInteraction {
  ADMIN_LOGIN = 'ADMIN_LOGIN',
  CLICK_COMING_SOON = 'CLICK_COMING_SOON',
  VIEW_TRAINING = 'VIEW_TRAINING',
  PREVIEW_TRAINING = 'PREVIEW_TRAINING',
  ADMIN_VIEW_TRAINING_TRACK = 'ADMIN_VIEW_TRAINING_TRACK',
  CHOOSE_LANGUAGE = 'CHOOSE_LANGUAGE',
  CUSTOMIZE_TRAINING = 'CUSTOMIZE_TRAINING',
  VIEWED_ADMIN_DASHBOARD = 'VIEWED_ADMIN_DASHBOARD',
  VIEWED_ADMIN_ASSIGNMENT = 'VIEWED_ADMIN_ASSIGNMENT',
  VIEWED_MANAGER_HUB = 'VIEWED_MANAGER_HUB',
  VIEWED_MANAGER_HUB_PROMO_MODAL = 'VIEWED_MANAGER_HUB_PROMO_MODAL',
  VIEWED_ONBOARDING_TOOLTIP = 'VIEWED_ONBOARDING_TOOLTIP',
}

export interface IUserInteraction {
  id: number;
  companyId?: number;
  userId?: number;
  targetEntity?: string;
  targetId?: number;
  sourceEntity?: string;
  sourceId?: number;
  interaction: UserInteraction;
  interactionValue?: string;
  interactionValueOther?: string;
  interactionTimestamp: string;
  createdBy: number;
}
